import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { TabTitle } from "../../../util/titleChanger";
import { GlobalState } from "../../../GlobalState";
import { deleteProduct } from "../../../action";
import { toast, ToastContainer } from "react-toastify";
import Loading from "../../../util/Loading";
import { api } from "../../../util/urlConfig";
import ReactPaginate from "react-paginate";

export default function ProductDashboard() {
  TabTitle("Product Dashboard");
  const state = useContext(GlobalState);
  const [products] = state.productAPI.products;
  const signInUser = JSON.parse(localStorage.getItem("user_data"));

  //Local state
  const [rowPerPage] = state.productAPI.rowPerPage;
  const [pageNumber, setPageNumber] = state.productAPI.pageNumber;
  const [totalPages] = state.productAPI.totalPages;
  const [setSearch] = state.productAPI.search;
  const [callback, setCallback] = state.productAPI.callback;

  useEffect(() => {}, [rowPerPage, products, pageNumber]);

  const pageNumberHandler = (data) => {
    let newPageNumber = data.selected + 1;
    setPageNumber(newPageNumber);
  };

  const searchHandler = (e) => {
    e.preventDefault();
    setPageNumber(1);
    setSearch(e.target.value ? e.target.value : "");
  };

  const deleteProductHandler = (id) => {
    deleteProduct(id, signInUser.id, (res) => {
      if (res.status === 200) {
        toast.success(res.data);
        setCallback(!callback);
      } else {
        toast.error(res.data);
        setCallback(!callback);
      }
    });
  };

  return (
    <div className="form-container">
      <div className="table">
        <div className="table_header">
          <p>Product Details</p>
          <div>
            <input type="text" name="search" id="search" placeholder="Search product here..." onChange={(e) => searchHandler(e)} />
            <Link to="/product-form">
              <button className="add_new">+ Add New</button>
            </Link>
          </div>
        </div>

        {products.count === 0 ? (
          <div className="loading-page-container">
            <Loading />
          </div>
        ) : (
          <div className="table_section">
            <table>
              <thead>
                <tr>
                  <th>Image</th>
                  <th>Product Code</th>
                  <th>Product Name</th>
                  <th>Category</th>
                  <th>Unit Price</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {products.count > 0 ? (
                  products.data.map((product) => (
                    <tr key={product.id}>
                      <td>
                        <img src={product.upload_image ? api + "/" + product.upload_image.image_url : "/img/dummy_avatar.png"} alt="product_image" />
                      </td>
                      <td>{product.product_code}</td>
                      <td>{product.name}</td>
                      <td>{product.category.name}</td>
                      <td>Rs {product.price}</td>
                      <td>
                        <Link to={`/product-form/${product.id}`}>
                          <button>
                            <i className="uil uil-edit"></i>
                          </button>
                        </Link>
                        <Link to={`/product-view/${product.id}`}>
                          <button>
                            <i className="uil uil-eye"></i>
                          </button>
                        </Link>
                        <button onClick={() => deleteProductHandler(product.id)}>
                          <i className="uil uil-trash-alt"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6">Can not found any products.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        <ReactPaginate
          breakLabel="..."
          nextLabel="next >"
          onPageChange={pageNumberHandler}
          marginPagesDisplayed={2}
          pageCount={totalPages}
          previousLabel="< previous"
          renderOnZeroPageCount={null}
          containerClassName="pagination"
          pageLinkClassName="page-num"
          previousLinkClassName="page-num"
          nextLinkClassName="page-num"
          activeLinkClassName="active-num"
        />
      </div>
      <ToastContainer />
    </div>
  );
}
